import React, { Fragment } from 'react';
import './TxtButton.css';

const TxtBtn = (props) => {
    const className = `txtBtn ${props.size}`;
    const {onClick} = props;
    //const icon = `img ${props.white} ${props.primary}`
    return <Fragment>
        <button className={className} onClick={onClick}>
            {props.label}
        </button>
    </Fragment>
}

export default TxtBtn;

//size: lg,md,sm   